import { render } from "./join.vue?vue&type=template&id=1ffac33e&scoped=true"
import script from "./join.vue?vue&type=script&lang=js"
export * from "./join.vue?vue&type=script&lang=js"

import "./join.vue?vue&type=style&index=0&id=1ffac33e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffac33e"]])

export default __exports__